module.exports = __webpack_public_path__ + "img/chuka.bd8941bc.jpg";